var map = {
	"./de": [
		7439,
		"src_locale_de_ts"
	],
	"./de.ts": [
		7439,
		"src_locale_de_ts"
	],
	"./en": [
		708,
		"src_locale_en_ts"
	],
	"./en.ts": [
		708,
		"src_locale_en_ts"
	],
	"./es": [
		230,
		"src_locale_es_ts"
	],
	"./es.ts": [
		230,
		"src_locale_es_ts"
	],
	"./fr": [
		4710,
		"src_locale_fr_ts"
	],
	"./fr.ts": [
		4710,
		"src_locale_fr_ts"
	],
	"./it": [
		5111,
		"src_locale_it_ts"
	],
	"./it.ts": [
		5111,
		"src_locale_it_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4887;
module.exports = webpackAsyncContext;